import React, { useEffect, useState } from "react";
import "./gameleader.css";
import SnakeImage from "../../../assets/images/game-snake.png";
import Snakepage from "../snake/snake";
import cancelIcon from "../../../assets/Task/cancelicon.svg";
import useUserInfo from "../../../Hooks/useUserInfo";
import { useAudio } from "../../../Providers/AudioProvider";
import Menu from "../../menu/menu";
import { GameLeaderBoardApi } from "../../../apis/user";
import SnakeGame from "../snake/snake";
import Dark2048 from "../2048/games2048";
import FruitSlice from "../fruitslice/FruitSlice";
import Twocar from "../cargame/comp/GameBoard";
import Minesweeper from "../minesweeper/minesweeper";

const GameLeaderboard = () => {
  const { userDetails, updateUserInfo, updatewatchScreenInfo, watchScreen } =
    useUserInfo();
  const playClick = useAudio();
  const SnakeImage = "https://d1ccopf5cw1hft.cloudfront.net/s3data/snake-1.png";
  // State for players data
  // const [topPlayers, setTopPlayers] = useState([
  //   { rank: 2, name: "Jay", score: 23456, avatar: "👨‍💼" },
  //   { rank: 1, name: "Bob", score: 23456, avatar: "👨‍🦰" },
  //   { rank: 3, name: "Sam", score: 23456, avatar: "👨‍🦱" },
  // ]);

  // const [otherPlayers, setOtherPlayers] = useState([
  //   { rank: 22, name: "ABHISHEK", score: 3450 },
  //   { rank: 23, name: "KAURU", score: 3400 },
  //   { rank: 24, name: "YOU", score: 3300, isUser: true },
  // ]);

  // Handlers for button clicks
  const goToThePage = (component, name) => {
    playClick();
    updateUserInfo((prev) => {
      return {
        ...prev,
        ...{
          currentComponent: component,
          currentComponentText: name,
          lastComponent: userDetails.currentComponent,
          lastComponentText: userDetails.currentComponentText,
          isMenu: false,
        },
      };
    });
  };
  const Page = userDetails?.currentComponentText;

  // Function to get the correct game component and name based on current component text
  const getGameComponent = (componentText) => {
    switch (componentText) {
      case "snake":
        return { component: SnakeGame, name: "SnakeGame" };
      case "2048F":
        return { component: Dark2048, name: "Dark2048" };
      case "fruitslice":
        return { component: FruitSlice, name: "FruitSlice" };
      case "carrace":
        return { component: Twocar, name: "Twocar" };
      case "minesweeper":
        return { component: Minesweeper, name: "Minesweeper" };
      default:
        return { component: SnakeGame, name: "SnakeGame" }; // Default fallback
    }
  };

  const handleReplay = () => {
    const gameInfo = getGameComponent(Page);
    goToThePage(gameInfo.component, gameInfo.name);
  };

  const handleRandomGame = () => {
    console.log("Start random game");
    // Add random game logic here
  };
  const toogleMenu = () => {
    playClick();
    updateUserInfo((prev) => ({
      ...prev,
      isPlay: false,
      currentComponent: Menu,
      currentComponentText: "MenuPage",
      lastComponent: userDetails?.userDetails.currentComponent,
      lastComponentText: userDetails?.userDetails.currentComponentText,
      isMenu: true,
      menuCount: userDetails?.userDetails?.menuCount + 1,
    }));
  };
  const [leaderboardData, setLeaderboardData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchLeaderBoard = async () => {
      updateUserInfo((prev) => ({
        ...prev,
        isLoading: true,
      }));
      const result = await GameLeaderBoardApi(
        userDetails?.currentComponentText,
        userDetails?.userDetails?.telegramId
      );

      if (result.success) {
        let data = result.data?.leaderboard;
        if (data?.length > 1) {
          [data[0], data[1]] = [data[1], data[0]];
        }

        setLeaderboardData(result?.data);
      } else {
        setError(result.error);
      }

      updateUserInfo((prev) => ({
        ...prev,
        isLoading: false,
      }));
    };

    fetchLeaderBoard();
  }, []);
  console.log(leaderboardData, "leaderboardData");

  const topPlayers = leaderboardData?.topThree;
  // const otherPlayers = leaderboardData?.slice(3,6);

  return (
    <div style={{ pointerEvents: "fill" }} className="container p-0 w-100">
      <img
        onClick={() => {
          const gameInfo = getGameComponent(Page);
          goToThePage(gameInfo.component, gameInfo.name);
        }}
        src="https://d1ccopf5cw1hft.cloudfront.net/s3data/Xicon.png"
        className="gameback-btn"
        style={{ cursor: "pointer" }}
      />
      <div className="game-container1">
        {/* Header */}
        <div className="header">
          <div className="header-title1 text-center">LEADERBOARD</div>
        </div>
        {/* Game Logo */}
        <div className="game-logo">
          <img
            style={{ borderRadius: "5px" }}
            src={
              Page == "2048F"
                ? "https://d1ccopf5cw1hft.cloudfront.net/s3data/twenty-1.png"
                : Page == "fruitslice"
                ? "https://d1ccopf5cw1hft.cloudfront.net/s3data/fruit-slice.png"
                : Page == "carrace"
                ? "https://d1ccopf5cw1hft.cloudfront.net/s3data/car-race.png"
                : Page == "minesweeper"
                ? "https://d1ccopf5cw1hft.cloudfront.net/s3data/minesweeper.png"
                : SnakeImage
            }
          />
        </div>
        <div className="leader-bottom">
          {/* Top 3 Players Cards */}
          <div className="top-players">
            {topPlayers?.map((player, index) => {
              if (!player) return null;

              const rankClasses = ["first", "second", "third"];
              const rankNumbers = [1, 2, 3];
              const medals = ["🥇", "🥈", "🥉"];

              return (
                <div className="top-player-card" key={index}>
                  <div className={`rank-badge ${rankClasses[index]}`}>
                    {medals[index]}
                  </div>
                  <div className="player-info">
                    <div className="player-name">{player?.name}</div>
                    <div className="player-score">{player?.score}</div>
                  </div>
                </div>
              );
            })}
          </div>

          {/* Leaderboard List */}
          {leaderboardData?.adjacentPositions?.length > 0 ? (
            <div>
              <div className="leaderboard-list">
                {leaderboardData?.adjacentPositions?.map((player, index) => (
                  <div
                    className={`leaderboard-item ${
                      player.isUser ? "highlighted" : ""
                    }`}
                    key={index}
                  >
                    <div className="rank">{player?.position}</div>
                    <div className="player-name">{player?.name}</div>
                    <div className="score1">{player.score}</div>
                  </div>
                ))}
                {leaderboardData?.currentUserPosition && (
                  <div className={`leaderboard-item highlighted`}>
                    <div className="rank">
                      {leaderboardData?.currentUserPosition.position}
                    </div>
                    <div className="player-name">{"You"}</div>
                    <div className="score1">
                      {leaderboardData?.currentUserPosition.score}
                    </div>
                  </div>
                )}
              </div>

              {/* Footer */}
              <div className="footer">
                <div>TIME TO MOVE UP, LET'S GO!</div>
              </div>
            </div>
          ) : (
            ""
          )}
          {/* Action Buttons */}
          <div className="action-buttons">
            <button className="btn-game-border" onClick={handleReplay}>
              REPLAY
            </button>
            {/* <button className=" btn-game" onClick={handleRandomGame}>
              RANDOM GAME
            </button> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default GameLeaderboard;
